import { FC } from 'react';
import { Grid, Stack, Typography } from '@mui/material';

import { useTranslationPrefix } from 'infrastructure/translations/i18n';

import { Container, ServiceDetailsField } from './common';

export type BasicServiceDetailsPreviewData = {
  service: string;
  scheduled: string;
  dueDate: string;
  recurringType: string;
  serviceLocation: string;
  estimatedTime: string;
  quantity: number;
  employeeCount: number;
  contractType: string;
};

export interface BasicServiceDetailsPreviewProps {
  data: BasicServiceDetailsPreviewData;
}

export const BasicServiceDetailsPreview: FC<BasicServiceDetailsPreviewProps> = ({ data }) => {
  const t = useTranslationPrefix('jobs.service_details.basic');
  return (
    <Container width={1} gap={4}>
      <Typography variant="h6">{t('title')}</Typography>
      <Grid container spacing={6}>
        <Grid item xs={6}>
          <Stack gap={4}>
            <ServiceDetailsField title={t('service_label')} value={data.service} />
            <ServiceDetailsField title={t('scheduled_label')} value={data.scheduled} />
            <ServiceDetailsField title={t('due_date_label')} value={data.dueDate} />
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack gap={4}>
            <ServiceDetailsField title={t('service_location_label')} value={data.serviceLocation} />
            <ServiceDetailsField title={t('estimated_time_label')} value={data.estimatedTime} />
            <ServiceDetailsField
              title={t('employee_count_label')}
              value={`${data.employeeCount} Employees`}
            />
          </Stack>
        </Grid>
      </Grid>
    </Container>
  );
};
